import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select, { components } from 'react-select';
import { withRouter } from 'react-router';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import constants from '../../constants';
import i18n from '../../i18n';
import _actions from '../../actions';

// eslint-disable-next-line no-unused-vars
const Option = ({ value, label }) => {
    return (
        <FontAwesomeIcon
            icon={['fal', value]}
            color="#616B7D"
        />
    );
};
const ValueContainer = ({ children, ...props }) => {
    return (
        components.ValueContainer && (
            // eslint-disable-next-line react/jsx-props-no-spreading
            <components.ValueContainer {...props}>
                {!!children && (
                    <FontAwesomeIcon
                        icon={['fal', 'search']}
                        color="#616B7D"
                    />
                )}
                {children}
            </components.ValueContainer>
        )
    );
};

// eslint-disable-next-line react/prefer-stateless-function
class UserSelectedIconSelect extends Component {
    constructor(props) {
        super(props);
        this.state = { icon: this.props.icon };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.icon !== this.props.icon) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ icon: this.props.icon });
        }
    }

    changeIcon = (e) => {
        this.props.actions.updateMenuItemParameter(this.props.match.params.projectId, this.props.id, this.props.type, 'icon', e.value);
    };

    changeIconWithoutSave = (e) => {
        this.props.changeIcon(constants.IconList.find((f) => {
            return f.value === e.value;
        }));
    }

    render() {
        return (
            <span className="btn-design-system medium icon user-icon">

                {this.props.autoUpdate
            && (
                <Select
                    formatOptionLabel={Option}
                    components={{ ValueContainer }}
                    options={constants.IconList}
                    className="icon-selector"
                    classNamePrefix="icon-selector"
                    value={constants.IconList.find((f) => {
                        return f.value === this.props.menuItems?.data?.find((m) => {
                            return m.subType === this.props.id;
                        })?.icon;
                    })}
                    onChange={(e) => {
                        this.changeIcon(e);
                    }}
                    clearable={false}
                    searchable
                    placeholder={i18n.t('selectPlaceholder')}
                />
            )}
                {!this.props.autoUpdate
                && (
                    <Select
                        formatOptionLabel={Option}
                        components={{ ValueContainer }}
                        options={constants.IconList}
                        className="icon-selector"
                        classNamePrefix="icon-selector"
                        value={this.state.icon}
                        onChange={(e) => {
                            this.changeIconWithoutSave(e);
                        }}
                        clearable={false}
                        searchable
                        placeholder={i18n.t('selectPlaceholder')}
                    />
                )}
            </span>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserSelectedIconSelect));
